import * as api from '../api';

export const getFaqFromServer = (slug_id) => {
  const endpoint = `/projects/${slug_id}/faq`;
  return api.get(endpoint);
};
